import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import { MobileTab } from 'modules/transmission/types'
import Tag from 'common/components/tag'
import Icons from 'common/components/icons'
import ViewerCounter from 'common/helpers/viewerCounter'
import useInitSparkie from 'modules/chat/hooks/useInitSparkie'
import { useChatContext } from 'modules/chat/context'
import { useTransmissionContext } from 'modules/transmission/context'

import './chatTabs.scss'

const ChatTabs = () => {
  const { t } = useTranslation()
  const { viewers, isChatActive, hasError, isLoading } = useChatContext()
  const {
    activeTab,
    setActiveTab,
    openLanguageModal,
    showOnfireLanguages
  } = useTransmissionContext()

  const { initSparkie } = useInitSparkie()

  const renderCounter = () => (
    <span>
      <Icons
        iconName="users"
        prefix="fas"/>
      {` `}
      {ViewerCounter.valueRounder(viewers)}
    </span>
  )

  const renderLanguageOptions = () => (
    <span>
      {t('general.language')}
      {` `}
      <Icons
        iconName="caret-down"
        prefix="fas"/>
    </span>
  )

  const tabs = [
    {
      'key': MobileTab.COUNTER,
      'children': renderCounter(),
      isLoading
    },
    ...(
      (isChatActive || isLoading || hasError)
        ? [{
          'key': MobileTab.CHAT,
          'children': t('chat.title'),
          ...(hasError && {
            onClick: () => {
              initSparkie()
              setActiveTab(MobileTab.CHAT)
            }
          }),
          isLoading
        }]
        : []
    ),
    {
      'key': MobileTab.INFORMATION,
      'children': t('online_event.information')
    },
    ...(
      showOnfireLanguages
        ? [{
          'key': MobileTab.LANGUAGE,
          'children': renderLanguageOptions(),
          'onClick': openLanguageModal
        }]
        : []
    )
  ]

  return (
    <div className="chat-tabs _d-flex">
      {tabs?.map(tab => {
        const isActive = tab.key === activeTab && !(tab.key === MobileTab.CHAT && hasError)

        const onClick = () => {
          isActive
            ? setActiveTab(void 0)
            : tab.key !== MobileTab.COUNTER && setActiveTab(tab.key)
        }

        return (
          <Tag
            key={`content-${tab.key}`}
            className={classnames('chat-tabs__tag _my-3 _mx-2', { 'active-tag': isActive })}
            onClick={tab.onClick || onClick}
            isLoading={tab.isLoading}>
            {tab.children}
          </Tag>
        )
      })}
    </div>
  )
}

export default ChatTabs
